import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

interface Toast {
  id: number;
  message: string;
  ton: 'ok' | 'bad';
}

const Contexte = createContext<{ ajouter: (message: string, ton?: 'ok' | 'bad') => void } | null>(null);

export function FournisseurToasts({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const ajouter = useCallback((message: string, ton: 'ok' | 'bad' = 'ok') => {
    const id = Date.now() + Math.random();
    setToasts((t) => [...t, { id, message, ton }]);
    // Un message d'erreur reste plus longtemps : il demande souvent une action.
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), ton === 'bad' ? 8000 : 4500);
  }, []);

  const valeur = useMemo(() => ({ ajouter }), [ajouter]);

  return (
    <Contexte.Provider value={valeur}>
      {children}
      {/* aria-live : les retours de mutation sont annoncés aux lecteurs d'écran. */}
      <div className="toasts" role="status" aria-live="polite">
        {toasts.map((t) => (
          <div key={t.id} className={`toast${t.ton === 'bad' ? ' bad' : ''}`}>{t.message}</div>
        ))}
      </div>
    </Contexte.Provider>
  );
}

export function useToasts() {
  const c = useContext(Contexte);
  if (!c) throw new Error('useToasts doit être utilisé dans FournisseurToasts.');
  return c;
}
